import fetcher from '../utils/api';

const organizationAdminService = {
  listAllOrganizations: async (id, searchQuery, sortBy, url) => {
    const additionalParams = [];

    if (searchQuery && searchQuery.trim().length > 1) {
      additionalParams.push(`query=${encodeURIComponent(searchQuery.trim())}`);
    }
    if (sortBy) {
      additionalParams.push(`sort_by=${sortBy}`);
    }
    if (url) {
      return fetcher(url, 'GET', true);
    }
    return fetcher(
      `super_organizations/${id}/organizations` + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`,
      'GET',
      true
    );
  },
  listSubOrganizations: async (id) => fetcher(`super_organizations/${id}/organizations_without_pagination`, 'GET', true),
  createSubOrganization: async (id, body) => fetcher(`super_organizations/${id}/organizations`, 'POST', true, body),
  deleteSubOrganization: async (orgId, newOrgId) => {
    const additionalParams = [];

    if (newOrgId) {
      additionalParams.push(`new_organization=${encodeURIComponent(newOrgId)}`);
    }
    const url = `organizations/${orgId}` + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}/`;

    return fetcher(url, 'DELETE', true);
  },
  updateSubOrganization: async (id, body) => fetcher(`organization_admin/${id}/`, 'PUT', true, body),
  listAllUsersFromOrg: async ({ id, searchQuery, role, sortBy, excludeViewers, url }) => {
    const additionalParams = [];

    if (url) {
      return fetcher(url, 'GET', true);
    }

    if (searchQuery && searchQuery.trim().length > 1) {
      additionalParams.push(`query=${encodeURIComponent(searchQuery.trim())}`);
    }

    if (role) {
      additionalParams.push(`role=${encodeURIComponent(role)}`);
    }

    if (sortBy) {
      additionalParams.push(`sort_by=${sortBy}`);
    }

    if (excludeViewers) {
      additionalParams.push(`exclude_viewers=${excludeViewers}`);
    }

    return fetcher(
      `super_organization/${id}/users_teams/` + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`,
      'GET',
      true
    );
  },
  listAllInvitesForSuperOrg: async (id, searchQuery, sortParam) => {
    const additionalParams = [];

    if (searchQuery && searchQuery.trim().length > 1) {
      additionalParams.push(`query=${encodeURIComponent(searchQuery.trim())}`);
    }
    if (sortParam) {
      additionalParams.push(`sort_by=${sortParam}`);
    }
    return fetcher(
      `scribe_invite/${id}/all_invites_for_super_org/` + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`,
      'GET',
      true
    );
  },
  deleteTeamsFromOrg: async (orgId, teamIds) =>
    fetcher(`super_organization/${orgId}/bulk_remove_organizations/`, 'POST', true, { organization_ids: teamIds }),
  addUsersToTeam: async (teamId, userIds) => fetcher(`organizations/${teamId}/bulk_add_users_to_team`, 'POST', true, { user_ids: userIds }),
  moveUsersToTeam: async (teamId, users) => fetcher(`organizations/${teamId}/bulk_move_users_to_team`, 'POST', true, { users }),
  removeUsersToTeams: async (superOrgId, users) =>
    fetcher(`organizations/${superOrgId}/bulk_remove_users_from_teams`, 'POST', true, { users }),
  getOrgDocumentsCount: async (id) => fetcher(`organizations/${id}/documents_count`, 'GET', true),
  deactivateUsers: async ({ superOrgId, userIds }) =>
    fetcher(`super_organization/${superOrgId}/deactivate_users/`, 'POST', true, { user_ids: userIds }),
  activateUsers: async ({ superOrgId, userIds }) =>
    fetcher(`super_organization/${superOrgId}/activate_users/`, 'POST', true, { user_ids: userIds }),
  changeDocumentsOwnership: async ({ superOrgId, data }) =>
    fetcher(`super_organization/${superOrgId}/bulk_change_documents_ownership/`, 'PUT', true, { data }),
  deleteDocuments: async ({ superOrgId, data }) =>
    fetcher(`super_organization/${superOrgId}/bulk_delete_documents/`, 'POST', true, { data }),
  getSpsConfiguration: async (id) => fetcher(`organization/${id}/sps_config/`, 'GET', true),
  updateSpsConfiguration: async (id, body) => fetcher(`organization/${id}/sps_config/`, 'PATCH', true, body)
};

export default organizationAdminService;
